export default __webpack_public_path__ + "static/media/banner.c593bceb.png";